import { SvgIcon, SvgIconProps } from "@mui/material";

export const SsoXmlFileIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
        fill="white"
        stroke="#DBDBDB"
      />
      <path
        d="M14.4 4.89844V0L21.6 7.2H16.8102C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
        fill="#D4D4D8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4613 8.42859C9.58711 8.42859 9.20171 8.5056 8.81053 8.7148C8.46225 8.90107 8.18677 9.17654 8.00051 9.52483C7.7913 9.91601 7.71429 10.3014 7.71429 11.1756V12.8244C7.71429 13.6986 7.7913 14.084 8.00051 14.4752C8.18677 14.8235 8.46225 15.099 8.81053 15.2852C9.20171 15.4944 9.58711 15.5714 10.4613 15.5714H13.5387C14.4129 15.5714 14.7983 15.4944 15.1895 15.2852C15.5378 15.099 15.8132 14.8235 15.9995 14.4752C16.2087 14.084 16.2857 13.6986 16.2857 12.8244V11.1756C16.2857 10.3014 16.2087 9.91601 15.9995 9.52483C15.8132 9.17654 15.5378 8.90107 15.1895 8.7148C14.7983 8.5056 14.4129 8.42859 13.5387 8.42859H10.4613ZM9.14739 9.34467C9.38336 9.21847 9.62741 9.14287 10.4613 9.14287H11.6429V10.5714H8.44809C8.47817 10.1968 8.54181 10.0273 8.63037 9.86168C8.75007 9.63787 8.92358 9.46436 9.14739 9.34467ZM11.6429 11.2857H8.42858V12.7143H11.6429V11.2857ZM12.3572 12.7143V11.2857H15.5714V12.7143H12.3572ZM11.6429 13.4286H8.44809C8.47817 13.8032 8.54181 13.9728 8.63037 14.1384C8.75007 14.3622 8.92358 14.5357 9.14739 14.6554C9.38336 14.7816 9.62741 14.8572 10.4613 14.8572H11.6429V13.4286ZM12.3572 14.8572V13.4286H15.5519C15.5218 13.8032 15.4582 13.9728 15.3696 14.1384C15.2499 14.3622 15.0764 14.5357 14.8526 14.6554C14.6167 14.7816 14.3726 14.8572 13.5387 14.8572H12.3572ZM12.3572 10.5714V9.14287H13.5387C14.3726 9.14287 14.6167 9.21847 14.8526 9.34467C15.0764 9.46436 15.2499 9.63787 15.3696 9.86168C15.4582 10.0273 15.5218 10.1968 15.5519 10.5714H12.3572Z"
        fill="#079455"
      />
    </svg>
  </SvgIcon>
);
